import React from 'react';
import { IItemForGetShortInfoWithStatus } from 'types';
import { Checkbox } from 'antd';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Text from 'components/Text/Text';
import { RestaurantMultipleSelect } from './RestaurantMultipleSelect';
import style from './index.module.scss';

interface IProps {
	setFetchedRestaurants: (value: IItemForGetShortInfoWithStatus[]) => void;
	setSelectedRestaurants: (value: string[]) => void;
	toggleApplyToOne: (value: boolean) => void;
	selectedRestaurants: string[];
	isApplyToOne: boolean;
	IDSelectedRestaurant: string;
	customerName: string;
	dishName: string;
	dishId: string;
}

export const RestaurantsBlock: React.FC<IProps> = React.memo(
	({
		setFetchedRestaurants,
		setSelectedRestaurants,
		toggleApplyToOne,
		selectedRestaurants,
		isApplyToOne,
		IDSelectedRestaurant,
		customerName,
		dishName,
		dishId,
	}) => {
		const handleToggleApplyToOne = () => {
			toggleApplyToOne(!isApplyToOne);
			setSelectedRestaurants([]);
		};

		return (
			<div className={style.container}>
				<div className={style.fieldWrapper}>
					<Text
						className={style.heading}
						translationNameSpace="form"
						translationKey="changesAppliesHeading"
						theme="secondary"
						size="l"
						weight="bold"
					/>
					<Checkbox className={style.checkBox} checked={isApplyToOne} onChange={handleToggleApplyToOne}>
						<Text
							translationNameSpace="form"
							translationKey="changesAppliesToRestaurantLabel"
							asFragment={true}
						/>
					</Checkbox>
				</div>
				<div className={style.fieldWrapper}>
					<div className={style.heading}>
						<Text
							translationNameSpace="form"
							translationKey="restaurantsHeading"
							theme="secondary"
							size="l"
							weight="bold"
						/>
						<Text
							className={style.hint}
							translationNameSpace="form"
							translationKey="restaurantSelectHint"
							theme="secondaryLight"
							size="s"
							weight="bold"
						/>
					</div>
					<div className={style.assignInfo}>
						<div>
							<FullInfoField label="customerLabel" />
							<Text translationKey={customerName} size="s" withTooltip={true} />
						</div>
						<div>
							<FullInfoField label="dishLabel" />
							<Text translationKey={dishName} size="s" withTooltip={true} />
						</div>
					</div>
					<RestaurantMultipleSelect
						setFetchedRestaurants={setFetchedRestaurants}
						setSelectedRestaurants={setSelectedRestaurants}
						selectedRestaurants={selectedRestaurants}
						isApplyToOne={isApplyToOne}
						IDSelectedRestaurant={IDSelectedRestaurant}
						dishId={dishId}
					/>
				</div>
			</div>
		);
	},
);
